import React from "react";
import WikiNavBar from "../components/navbar";
import { Tabs, Tab } from "react-bootstrap";
import Login from '../components/login';
import { navigate } from "@reach/router";
import Register from '../components/register';

const LoginPage = (props) => {
  return (
    <>
      <WikiNavBar />
      <div className="container">
      <Tabs style={{marginTop: 55}} defaultActiveKey="login" id="uncontrolled-tab-example">
        <Tab eventKey="login" title="Iniciar Sesión">
          <Login style={{marginTop: 25}} onSuccess={() => {
            navigate('/')
          }} />
        </Tab>
        <Tab eventKey="register" title="Registrarse">
          <Register style={{marginTop: 25}} onSuccess={() => {
            navigate('/')
          }} />
        </Tab>
      </Tabs>
      <div style={{marginTop: 255}} />
      </div>
    </>
  );
};

export default LoginPage;
